const triggerFaq = ( trigger ) => {
    const content = trigger.closest('.faq__card').querySelector('.faq__content ');
    if ( content.classList.contains('faq__content--show') ) {
        trigger.classList.remove('faq__trigger--up')
        trigger.classList.add('faq__trigger--down')
        content.classList.remove('faq__content--show')
        content.classList.add('faq__content--hidden')
    } else if ( content.classList.contains('faq__content--hidden') ) {
        trigger.classList.remove('faq__trigger--down')
        trigger.classList.add('faq__trigger--up')
        content.classList.remove('faq__content--hidden')
        content.classList.add('faq__content--show')
    }
}